var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgECommercetab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 765 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-20,.cls-22,.cls-23,.cls-31,.cls-32,.cls-35,.cls-36,.cls-5{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#d8c4df;}.cls-4{fill:#e7b7b7;}.cls-5{stroke:#565349;stroke-width:0.74px;}.cls-31,.cls-32,.cls-35,.cls-36,.cls-5{stroke-miterlimit:10;}.cls-25,.cls-26,.cls-27,.cls-28,.cls-30,.cls-6{fill:#2f2143;}.cls-7{fill:#f9f9fc;}.cls-8{fill:#9e5ca5;}.cls-9{fill:#1f3242;}.cls-10{fill:#966666;}.cls-11{fill:#e3a2a2;}.cls-12{fill:#9cbfe5;}.cls-13{opacity:0.6;}.cls-14{clip-path:url(#clip-path);}.cls-15{fill:#fdc435;}.cls-16{clip-path:url(#clip-path-2);}.cls-17{clip-path:url(#clip-path-3);}.cls-18{clip-path:url(#clip-path-4);}.cls-19{fill:#33144e;}.cls-19,.cls-20,.cls-22,.cls-23{stroke:#231f20;}.cls-19,.cls-20{stroke-width:0.17px;}.cls-21{fill:#231f20;}.cls-22,.cls-23{stroke-width:0.09px;}.cls-22{stroke-dasharray:0.52 0.35;}.cls-24{fill:#9a499c;}.cls-25{font-size:17.42px;}.cls-25,.cls-26,.cls-27,.cls-28,.cls-33{font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-26{font-size:35px;}.cls-27{font-size:21.72px;}.cls-28{font-size:21.28px;}.cls-29{fill:#8a56a3;}.cls-30{mix-blend-mode:multiply;}.cls-31,.cls-32,.cls-35,.cls-36{stroke:#2f2143;}.cls-31{stroke-width:1.19px;}.cls-32,.cls-36{stroke-linecap:round;}.cls-32{stroke-width:4.08px;}.cls-33{font-size:9.11px;}.cls-33,.cls-34{fill:#fff;}.cls-35{stroke-width:1.01px;}.cls-36{stroke-width:1.34px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.53,
    y: 90.43,
    width: 86.3,
    height: 66.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.53,
    y: 63.22,
    width: 29.74,
    height: 18.86
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 185.65,
    y: 97.81,
    width: 66.49,
    height: 43.76
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 151.52,
    y: 30.54,
    width: 92.64,
    height: 42.13
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E-commerce tab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 765,
    height: 277
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210.72,139.71c.22-1,1.54-3.53-1.76-6.55-1.65-1.5-3.85-6.7-4.22-7.31-1.17-1.95-1.42-5.38-1.7-6.14-.12-.33,1.35-1.52,3.06,0,.68.59,1.19,1.6,1.74,3.55.29,1,1.89,3.38,2.69,3.27,1-.14,1.6-.68,1.72-2.06.29-3.51-4.12-15-3.66-16.06a1.72,1.72,0,0,1,3.15.27c.51,1.22,2,5.75,2.8,5.62.49-.07.34-4.45.15-8.5a1.56,1.56,0,0,1,3-.89c.49,2.57.87,4.77,1.23,5s.52-1.81.69-2.34a1.5,1.5,0,0,1,2.89.1c.08.45.71,7.55,1.56,7.59.56,0,.51-2.27.59-2.5.53-1.66,2.85-1.39,2.8.67,0,1.79-.14,9.56-.28,11.49a99.68,99.68,0,0,1-2.68,18.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M224.46,143.38C221.93,155.2,220,199.14,212,202.15c-8.22,3.09-26.74-9.52-26.74-9.52l8.8-21.55,7,5.38c2.39-12.74,9.73-36.75,9.73-36.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M201,176.46A40.43,40.43,0,0,0,201,189"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M214.62,125.78c4.59,1.49,6.44,6.44,6.44,6.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M214.54,114.25c.59,1.9,1.26,5.44,1.26,5.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M218.89,109.9c.61,4.36.86,9.79.86,9.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M224,115.25c.06,1.25,0,5,0,5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.16,139.71c-.22-1-1.54-3.53,1.76-6.55,1.65-1.5,3.85-6.7,4.22-7.31,1.16-1.95,1.42-5.38,1.69-6.14.13-.33-1.34-1.52-3,0-.68.59-1.19,1.6-1.74,3.55-.29,1-1.89,3.38-2.69,3.27-1-.14-1.61-.68-1.72-2.06-.3-3.51,4.12-15,3.66-16.06a1.72,1.72,0,0,0-3.15.27c-.51,1.22-2,5.75-2.8,5.62-.49-.07-.34-4.45-.15-8.5a1.56,1.56,0,0,0-3-.89c-.49,2.57-.88,4.77-1.23,5s-.53-1.81-.69-2.34a1.5,1.5,0,0,0-2.89.1c-.08.45-.72,7.55-1.56,7.59-.57,0-.51-2.27-.59-2.5-.53-1.66-2.85-1.39-2.81.67,0,1.79.14,9.56.28,11.49a100.14,100.14,0,0,0,2.69,18.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57.42,143.38c2.52,11.82,4.47,55.76,12.48,58.77,8.22,3.09,26.74-9.52,26.74-9.52l-8.8-21.55-7,5.38c-2.39-12.74-9.73-36.75-9.73-36.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M80.89,176.46a40.82,40.82,0,0,1,0,12.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.26,125.78c-4.59,1.49-6.44,6.44-6.44,6.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.34,114.25c-.59,1.9-1.26,5.44-1.26,5.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63,109.9c-.61,4.36-.86,9.79-.86,9.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.85,115.25c-.06,1.25,0,5,0,5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M140,276.94c.63-2.77.95-4.11.95-4.11s.35,1.35,1.05,4.11c11.91-.12,24,0,35.74,0-1.39-17.3-2.85-33.94-2.85-33.94H107s-1.72,16.12-3.29,33.94C115.81,276.92,127.91,277.06,140,276.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M164.14,149.5H117.88v95c15.08,4.4,46.26,1,46.26,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.37,149.5c.58,6.73-3.33,13-12.43,13-12.55,0-12.55-13-12.55-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M136.32,166c3.36,12-1.47,85-1.47,85-18.9.81-29.94-4.26-29.94-4.26l4.53-60.2L93.64,197.2c-6.24-2.47-10.19-24.26-10.19-24.26s25.87-23.44,34.43-23.44H131C120.36,157,136.32,166,136.32,166"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M145.7,166c-3.36,12,1.47,85,1.47,85,18.9.81,29.94-4.26,29.94-4.26l-4.53-60.2,15.8,10.66c6.25-2.47,10.2-24.26,10.2-24.26s-25.87-23.44-34.44-23.44H151.07C161.66,157,145.7,166,145.7,166"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M131,149.5l.46-4.79s-4.55,2-6.58,4.79,0,20.8,0,20.8,3.85-5.67,5.11-5.81,6.37,1.47,6.37,1.47S127,155,131,149.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M151.07,149.5l-.34-4.79s4.42,2,6.45,4.79,0,20.8,0,20.8-3.85-5.67-5.11-5.81S145.7,166,145.7,166s9.33-11,5.37-16.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M172.58,186.54c-1-3.82-2.07-15.37-2.07-15.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M109.45,186.54c.52-5.12,1.78-16.77,1.78-16.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M118.62,115.59c1.81,6.07,4,7.86,8.64,9.74l21.67,9.07c6.39-6.91,7.67-10.12,7.67-19.51,4.08-8.19-1.28-21.31-9.72-18.8-7.37-11.76-40.34,4-28.26,19.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.67,152.4c.65,1.73,4.71,6.29,9.69,6.29,7.27,0,10.85-6,10.85-8.49l-2.65-30-15.47,3.12c.22,2.27-1.75,22.4-2.42,29.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M132.43,133.71,145,132.5s-.59,10-13.45,11.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.37,109.67c-3,4.76-1,7.35-1,12.09,0,5.09-2,12.31,2.13,16.07s14,4.09,20.7-4.35,5.22-22.75-2.13-26.43c-6.28-3.14-15.58-4-19.73,2.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M119.44,115.59c5.42.75,8.71-6.16,14.55-7.55a7.4,7.4,0,0,0,6.4,6.62c5.33,2.56,4.46,9.36,6.3,9.36,1.07,0,1-4.56,1.9-6,3.81-6.07,1.55-12.37-5.05-15.3s-14.8-3.85-19.4,0-4.7,12.9-4.7,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M126.52,129.1c-2.33,0-2.79-.47-3.16-1.08-.23-.39,0-1.13.47-2.78a33.15,33.15,0,0,0,.93-3.59.26.26,0,0,1,.31-.22.27.27,0,0,1,.22.32,35.37,35.37,0,0,1-.93,3.65,9.81,9.81,0,0,0-.55,2.3c.25.42.5.85,2.71.85a.27.27,0,0,1,.27.27.28.28,0,0,1-.27.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M141.79,123a2.6,2.6,0,1,1-3.65-1.37,2.77,2.77,0,0,1,3.65,1.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M131.07,119.42c0,1-.47,1.79-1,1.79s-1.05-.8-1.05-1.79.47-1.78,1.05-1.78,1,.8,1,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M128.15,116.16c.22.74,2.1-.61,3.2-.5,1.88.19,2,1.13,2.63,1,.1-.86-1.1-2-2.73-2.07a3,3,0,0,0-3.1,1.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M123.23,120.2c0,.82-.39,1.48-.87,1.48s-.87-.66-.87-1.48.39-1.48.87-1.48.87.66.87,1.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M123.66,117.22c0,.59-1.58,0-2.27.29-1.14.5-1.18,1.42-1.5,1.28a1.86,1.86,0,0,1,1.24-2.09,2.25,2.25,0,0,1,2.53.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M132.3,129.67a13.12,13.12,0,0,1-5.21,2.83,6.74,6.74,0,0,0,4,1c1.88-.33,1.23-3.83,1.23-3.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.59,118a3.71,3.71,0,0,1,6.54,1.35c.61,2.1,0,8-6,7.63,0,0-1.94-7.2-.57-9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M149.41,123.65h.08a.33.33,0,0,0,.24-.39c-.39-1.57,0-3.25,1-3.89a1.53,1.53,0,0,1,1.85.13.34.34,0,0,0,.46-.09.32.32,0,0,0-.09-.45,2.17,2.17,0,0,0-2.59-.13c-1.16.81-1.68,2.73-1.23,4.58a.33.33,0,0,0,.32.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M97.23,122.63a3.62,3.62,0,0,0-3.53-3.24,2.91,2.91,0,0,0-3,3.24,3.6,3.6,0,0,0,3.52,3.24,2.93,2.93,0,0,0,3-3.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M98.2,133.71a3.62,3.62,0,0,0-3.53-3.24,2.93,2.93,0,0,0-3,3.24A3.62,3.62,0,0,0,95.24,137a2.93,2.93,0,0,0,3-3.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M96.26,111.56a2.92,2.92,0,0,1-3,3.24,3.6,3.6,0,0,1-3.52-3.24,2.91,2.91,0,0,1,3-3.24,3.62,3.62,0,0,1,3.53,3.24"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M99.87,156.87H24.78a3,3,0,0,1-2.94-2.7l-5.3-60.52a3,3,0,0,1,2.95-3.22H94.58a3,3,0,0,1,3,2.7l5.29,60.53a3,3,0,0,1-2.95,3.21"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "93.76 67.69 84.04 67.69 83.97 66.88 93.69 66.88 93.76 67.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "88.24 69.4 84.19 69.4 84.12 68.59 88.17 68.59 88.24 69.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "94.06 71.11 84.34 71.11 84.27 70.3 93.99 70.3 94.06 71.11"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M72.62,82.09H95.31a3,3,0,0,0,3-3.22l-1.13-13a3,3,0,0,0-2.95-2.7H71.49a3,3,0,0,0-2.95,3.22l1.13,13a3,3,0,0,0,3,2.7"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M80.82,76.5c.18,2.11-1.58,2.65-3.82,2.65s-4.1-.54-4.29-2.65a3.56,3.56,0,0,1,3.72-3.83,4.39,4.39,0,0,1,4.39,3.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M78.36,68.59a2.72,2.72,0,0,0-2.65-2.43,2.2,2.2,0,0,0-2.22,2.43A2.71,2.71,0,0,0,76.14,71a2.2,2.2,0,0,0,2.22-2.43"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M245.87,141.56H188.6a3,3,0,0,1-2.94-3.21L189,100.51a3,3,0,0,1,2.94-2.7h57.27a3,3,0,0,1,2.94,3.21l-3.31,37.84a3,3,0,0,1-2.94,2.7"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M239.31,72.67H154.48a3,3,0,0,1-2.95-3.11l1.9-36.22a3,3,0,0,1,2.95-2.8h84.83a3,3,0,0,1,2.95,3.11l-1.9,36.22a3,3,0,0,1-2.95,2.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M48.69,102.4s-4.21,2.46-5.46,3-2.91,1-3.66,2-3.06,3.91-3.81,4.86-3.21,3.56-3.21,3.56a15.82,15.82,0,0,1,1.76,2c.55.85,3.56,3.06,4.86,4a19,19,0,0,1,.85-2.21,20.43,20.43,0,0,1,.55,3.11c0,1.15,0,6.82.15,8.87s.35,3.66.5,6.27.05,6.32.05,6.32,5,.15,6.62,0a61.75,61.75,0,0,1,7.62-.35c2.91.15,6.52.5,7.62.45s3.41-.25,3.41-.25-.2-4.76-.1-6.87.35-5.06.4-6.87,0-7.12-.15-8.22-.15-3.21-.15-3.21a20.48,20.48,0,0,1,1.5,2.71,15.77,15.77,0,0,0,3.26-2.66c.75-.7,2.46-1.9,2.46-1.9s-2.11-2.71-2.81-3.76-2.81-3.66-3.31-4.67-1.1-1.2-2.35-2l-6.42-4.06-1.95.45-4.92.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M57.07,103.45a7.48,7.48,0,0,1-.91,1.66,4.17,4.17,0,0,1-3.26.9c-1.45-.1-2.7-1.81-3-2.71A15.21,15.21,0,0,0,57.07,103.45Zm-7.47-1.9-1.31,1a4.84,4.84,0,0,0,1,2.56,5.1,5.1,0,0,0,4.16,2.35,6.73,6.73,0,0,0,4.06-1.9,28.23,28.23,0,0,0,1.35-3l-1.1-.9a11.13,11.13,0,0,1-4.61.7A7.14,7.14,0,0,1,49.6,101.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M40,119.54c.55-1.3,1.5-3.56,1.45-5s-.55-7.27-.7-8.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M66.54,118.84a18.42,18.42,0,0,1-1.35-6,23.54,23.54,0,0,1,.35-6.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M43.63,105.21c.76-.4,1.55-.71,2.32-1.06s1.58-.64,2.39-.9c-.75.4-1.55.7-2.32,1.06S44.44,105,43.63,105.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M58.62,103.3c.93.34,1.83.77,2.74,1.15s1.8.83,2.67,1.31c-.93-.34-1.82-.77-2.74-1.15S59.49,103.78,58.62,103.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M49.9,103.3a5.79,5.79,0,0,1-.3-1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M57.07,103.45c.2-.6.5-1.1.7-1.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M33,115.23c.85.7,2.06,2.61,2.56,3.06a29.6,29.6,0,0,0,3.81,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M33.25,115c.86.7,2.06,2.61,2.56,3.06a29.6,29.6,0,0,0,3.81,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M67.69,120.7a16.86,16.86,0,0,0,3.21-2.46,9.23,9.23,0,0,1,2.36-1.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M67.54,120.45A16.86,16.86,0,0,0,70.75,118a9.3,9.3,0,0,1,2.36-1.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 48.58,
    y1: 102.71,
    x2: 49.36,
    y2: 102.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 48.71,
    y1: 103.2,
    x2: 49.38,
    y2: 102.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 49.48,
    y1: 103.14,
    x2: 48.83,
    y2: 103.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 49.69,
    y1: 103.61,
    x2: 48.97,
    y2: 104
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 49.85,
    y1: 103.88,
    x2: 49.24,
    y2: 104.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 50.04,
    y1: 104.24,
    x2: 49.55,
    y2: 104.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 50.2,
    y1: 104.57,
    x2: 49.73,
    y2: 105.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 50.43,
    y1: 104.8,
    x2: 49.93,
    y2: 105.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 50.61,
    y1: 105.1,
    x2: 50.22,
    y2: 105.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 50.9,
    y1: 105.35,
    x2: 50.47,
    y2: 105.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 51.16,
    y1: 105.6,
    x2: 50.73,
    y2: 106.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 51.49,
    y1: 105.86,
    x2: 51.08,
    y2: 106.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 51.76,
    y1: 105.96,
    x2: 51.45,
    y2: 106.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 52.12,
    y1: 106.09,
    x2: 51.88,
    y2: 106.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 52.43,
    y1: 106.19,
    x2: 52.29,
    y2: 107.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 52.9,
    y1: 106.33,
    x2: 52.82,
    y2: 107.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 53.41,
    y1: 106.33,
    x2: 53.43,
    y2: 107.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 53.78,
    y1: 106.29,
    x2: 53.91,
    y2: 106.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 54.23,
    y1: 106.25,
    x2: 54.36,
    y2: 106.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 54.64,
    y1: 106.17,
    x2: 54.83,
    y2: 106.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 55.09,
    y1: 106.05,
    x2: 55.32,
    y2: 106.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 55.54,
    y1: 105.88,
    x2: 55.85,
    y2: 106.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 55.95,
    y1: 105.66,
    x2: 56.36,
    y2: 106.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 56.34,
    y1: 105.33,
    x2: 56.81,
    y2: 105.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 56.61,
    y1: 105,
    x2: 57.24,
    y2: 105.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 56.89,
    y1: 104.57,
    x2: 57.45,
    y2: 104.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 57.06,
    y1: 104.14,
    x2: 57.67,
    y2: 104.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 57.28,
    y1: 103.69,
    x2: 57.88,
    y2: 104.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 57.45,
    y1: 103.22,
    x2: 57.96,
    y2: 103.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 57.59,
    y1: 102.83,
    x2: 58.24,
    y2: 103.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 57.79,
    y1: 102.38,
    x2: 58.41,
    y2: 102.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 50.04,
    y1: 102.1,
    x2: 49.96,
    y2: 102.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 50.38,
    y1: 102.24,
    x2: 50.22,
    y2: 103.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 50.79,
    y1: 102.34,
    x2: 50.69,
    y2: 103.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 51.24,
    y1: 102.44,
    x2: 51.12,
    y2: 103.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 51.63,
    y1: 102.57,
    x2: 51.57,
    y2: 103.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 52.06,
    y1: 102.61,
    x2: 51.98,
    y2: 103.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 52.49,
    y1: 102.69,
    x2: 52.49,
    y2: 103.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 53,
    y1: 102.67,
    x2: 52.98,
    y2: 103.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 53.39,
    y1: 102.71,
    x2: 53.45,
    y2: 103.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 53.88,
    y1: 102.71,
    x2: 53.97,
    y2: 103.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 54.31,
    y1: 102.71,
    x2: 54.46,
    y2: 103.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 54.85,
    y1: 102.67,
    x2: 55.03,
    y2: 103.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 55.38,
    y1: 102.57,
    x2: 55.77,
    y2: 103.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 55.99,
    y1: 102.53,
    x2: 56.24,
    y2: 103.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 56.52,
    y1: 102.38,
    x2: 56.79,
    y2: 103.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 56.98,
    y1: 102.22,
    x2: 57.1,
    y2: 102.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M205.15,50.14,170.88,64.89s-3.13-5.85,2.74-9.48c6.28-3.88,12.63-7.21,12.7-8.4s-1.41-2.52-1.15-3.84c.19-.94,1.35-2.12,2.19-1.48,1.57,1.19,1.31,3.27,2.76,3.1,4-.49,8.44-3.39,8.83-4.8s3-.78,3.08,2.11c.08,3.24,2.88,5.34,3.12,8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 169.71,
    y: 57.44,
    width: 37.33,
    height: 1.84,
    transform: "translate(-7.72 79.25) rotate(-23.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M187.87,49.27c0,1-3.89,3.08-6.54,4.44-1.9,1-3.9-.6-3.9-.6,4.8-2.85,8.83-5.15,8.89-6.1,0,0,1.55,1.25,1.55,2.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M194.21,51.93c1.42-2.5,2.89-5.07,8.27-7.69q.14.34.3.69c-5.15,2.52-6.56,5-7.92,7.37a18.28,18.28,0,0,1-2.13,3.19l-2,.86a13.65,13.65,0,0,0,3.5-4.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M173.57,55.45l.05,0,.58-.36c1.94,3,8.71,1.79,8.78,1.77l.13.74c-.31.06-7.35,1.31-9.54-2.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M225.7,63.74,188.4,64.9s-.76-6.59,6-7.82c7.26-1.31,14.39-2.07,14.89-3.16s-.39-2.85.34-4c.52-.8,2-1.48,2.58-.57,1,1.68,0,3.52,1.43,3.89,3.93,1,9.1,0,10-1.23s3.07.38,2.09,3.09c-1.11,3,.72,6,0,8.63"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 188.41,
    y: 64.32,
    width: 37.33,
    height: 1.84,
    transform: "translate(-1.94 6.5) rotate(-1.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M209.93,56.6c-.37.94-4.74,1.44-7.71,1.72-2.12.21-3.41-2-3.41-2,5.52-.89,10.11-1.55,10.51-2.42,0,0,1,1.74.61,2.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M214.86,61.39c2.23-1.8,4.54-3.65,10.51-4.12,0,.25,0,.51,0,.75-5.72.46-7.93,2.23-10.07,4a18.55,18.55,0,0,1-3.16,2.18l-2.19.07a13.58,13.58,0,0,0,4.88-2.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M194.36,57.1l.07,0,.67-.11c.71,3.49,7.44,4.85,7.51,4.86l-.14.74c-.31-.06-7.32-1.48-8.11-5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M208.73,136.55a29.7,29.7,0,0,0,7.75.14s.55-13.16.62-15.44c.11-3.78,2.06-12,2.06-12s2,7.84,2.7,11.56c.6,3.41,1.38,16.14,1.38,16.14a26.1,26.1,0,0,0,7.53,0s-1.32-14.61-1.52-18.74-1.31-16.68-1.31-16.68H210.38s-1.47,13.83-1.47,18.27c0,5.22-.18,16.71-.18,16.71"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 39.37,
    cy: 229.39,
    r: 12.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 39.37,
    cy: 229.39,
    r: 11.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-25",
    transform: "translate(34.49 235.57)"
  }, "$"), /*#__PURE__*/React.createElement("text", {
    className: "cls-26",
    transform: "translate(270.57 156.57)"
  }, "E-COMMERCE"), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 516.58,
    cy: 76.1,
    r: 16.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 516.58,
    cy: 76.1,
    r: 13.92
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-27",
    transform: "translate(510.49 83.8)"
  }, "$"), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 361.53,
    cy: 57.83,
    r: 15.87
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-28",
    transform: "translate(352.38 65.93)"
  }, "%"), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 642.23,
    y: 43.52,
    width: 76.22,
    height: 39.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 699.52,
    cy: 74.05,
    r: 5.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 706.37,
    cy: 74.05,
    r: 5.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 647.98,
    y: 51.53,
    width: 41.65,
    height: 2.8,
    rx: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 651.67,
    y: 74.05,
    width: 5.42,
    height: 4.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 659.07,
    y: 74.05,
    width: 5.42,
    height: 4.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 666.34,
    y: 74.05,
    width: 5.42,
    height: 4.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 624.36,
    y: 207.7,
    width: 36.22,
    height: 36.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 639.8,
    y: 207.7,
    width: 36.22,
    height: 36.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 625.75,
    y: 209.09,
    width: 33.44,
    height: 33.44
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "710.82 244.26 613.88 244.26 597.9 181.05 728.58 181.05 710.82 244.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 616.37,
    y1: 181.05,
    x2: 632.35,
    y2: 244.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 709.76,
    y1: 181.05,
    x2: 692.18,
    y2: 244.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 689.13,
    y1: 181.05,
    x2: 671.55,
    y2: 244.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 639.98,
    y1: 181.05,
    x2: 654.89,
    y2: 244.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 663.24,
    y1: 244.26,
    x2: 663.24,
    y2: 181.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M601,193.1c.13.51,124.24,0,124.24,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 605.59,
    y1: 211.45,
    x2: 719.08,
    y2: 211.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 610.06,
    y1: 229.13,
    x2: 715.07,
    y2: 229.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M597.9,181.05s-4.08-20-17.22-16.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 559.2,
    y: 161.06,
    width: 21.48,
    height: 7.81,
    rx: 3.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M615.33,245.67a17.89,17.89,0,0,0,4.79,9.39c5.3,5.19,12.76,4.73,26.63,4.4,10-.24,20.07,0,30.1-.27,7.76-.17,18.89-.25,32.49.27"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 645.84,
    cy: 260.05,
    r: 7.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 684.01,
    cy: 260.05,
    r: 7.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 354.94,
    y: 233.29,
    width: 67.43,
    height: 14.54,
    rx: 5.61
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-33",
    transform: "translate(359.15 244.13)"
  }, "ADD TO CART"), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 582.86,
    y: 121.05,
    width: 150.93,
    height: 14.1,
    rx: 6.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-35",
    cx: 721.25,
    cy: 126.27,
    r: 2.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 722.21,
    y1: 128.09,
    x2: 725,
    y2: 131.89
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgECommercetab);
export default __webpack_public_path__ + "static/media/E-commerce tab.509403c288bde0eccb00f47ff1fdde5f.svg";
export { ForwardRef as ReactComponent };